import { Reveal } from "@/components/Reveal";

export const Director = () => (
  <section data-testid="director-section" className="relative overflow-hidden bg-[#0C5F8A] py-20 sm:py-28">
    <div className="pointer-events-none absolute -left-32 -top-32 h-96 w-96 rounded-full bg-[#1BA8E0]/20" aria-hidden="true" />
    <div className="pointer-events-none absolute -bottom-40 -right-24 h-[26rem] w-[26rem] rounded-full bg-[#1BA8E0]/10" aria-hidden="true" />
    <div className="relative mx-auto max-w-4xl px-5 sm:px-8">
      <Reveal className="text-center">
        <p className="font-display text-xs font-semibold uppercase tracking-[0.25em] text-[#F5B21B]">
          Mensaje del director
        </p>
        <h2 className="mt-3 font-display text-2xl font-bold tracking-tight text-white sm:text-3xl lg:text-4xl">
          Una palabra de quien está detrás
        </h2>
      </Reveal>

      <Reveal delay={0.15}>
        <figure
          data-testid="director-card"
          className="relative mt-14 rounded-2xl bg-white px-7 pb-12 pt-20 shadow-[0_28px_60px_-18px_rgba(6,39,59,0.55)] sm:px-14"
        >
          <span aria-hidden="true" className="absolute left-7 top-6 select-none font-editorial text-8xl leading-none text-[#F5B21B] sm:left-10 sm:text-9xl">
            “
          </span>

          {/* Espacio preparado: para usar la foto del director, reemplazar este monograma por
              <img src="/assets/director.jpg" alt="Rodolfo Alfonso Santana López, Director General de Seguclick"
                   className="h-24 w-24 rounded-full object-cover ring-4 ring-[#F5B21B]/60" /> */}
          <div className="relative z-10 mx-auto -mt-32 mb-8 flex h-24 w-24 translate-y-2 items-center justify-center rounded-full bg-[#1BA8E0] font-display text-3xl font-extrabold text-white ring-4 ring-[#F5B21B]/70 shadow-[0_14px_30px_-8px_rgba(27,168,224,0.6)]">
            RS
          </div>

          <blockquote className="relative z-10 mx-auto max-w-2xl text-center">
            <p className="text-base leading-relaxed text-[#2E3338]/85 sm:text-lg">
              Aprendí este oficio de mi padre, viendo cómo trataba a cada cliente como parte de la familia.
              Llevo más de 40 años honrando esa enseñanza. Para mí, un seguro no es un papel: es la promesa
              de que no estarás solo cuando algo pase. Esa promesa la cumplimos todos los días.
            </p>
          </blockquote>

          <figcaption className="relative z-10 mt-9 text-center">
            <p className="font-script text-4xl text-[#0C5F8A] sm:text-5xl">Rodolfo Alfonso Santana López</p>
            <p className="mt-2 font-display text-xs font-semibold uppercase tracking-[0.25em] text-[#1BA8E0]">
              Director General
            </p>
          </figcaption>
        </figure>
      </Reveal>
    </div>
  </section>
);
